//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Builder.js";
import "../no/ListCreatorList.js";
import "../no/SelectNXObjectList.js";
import "../no/ListCreator.js";
import "../no/SelectObjectList.js";
import "../no/ObjectList.js";
let d=[[[0,"AdvancedMaterial",1,0],[0,"AppendRefset",1,0],[0,"ApplyPmi",1,0],[0,"AsmStructure",1,0],[0,"AutolowLod",1,0],[0,"ChordalOption",1,0],[0,"ConfigFile",1,0],[0,"IncludePmi",1,0],[0,"JtParts",1,0],[0,"JtWrite",1,0],[0,"JtfileStructure",1,0],[0,"Kinematics",1,0],[0,"LightTextureMaterial",1,0],[0,"LighweightLabel",1,0],[1,"LodList",0,"ListCreatorList",0],[0,"MergeSheets",1,0],[0,"MergeSolids",1,0],[0,"OutputJtFile",1,0],[0,"PreciseGeom",1,0],[1,"SelectBody",0,"SelectNXObjectList",0],[0,"SmartLod",1,0],[0,"TessOption",1,0],[0,"UseRefset",1,0],[0,"WireFrame",1,0]],[[[],"NewLevel",{R_:{builder:"ListCreator"}},0,0],[[],"LoadConfigSettings",{},0,0]],[]];
SPLM.JtCreator = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.JtCreator";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.JtCreator.ChordalValue = Object.freeze({
    "Relative" : "Relative", "Absolute" : "Absolute", "PerLod" : "PerLod"});

SPLM.JtCreator.FileStructure = Object.freeze({
    "PerPart" : "PerPart", "Monolithic" : "Monolithic", "FullShatter" : "FullShatter", "Mimic" : "Mimic", "Plmxml" : "Plmxml", "Ap242xml" : "Ap242xml"});

SPLM.JtCreator.FileWrite = Object.freeze({
    "All" : "All", "PartsOnly" : "PartsOnly", "AssemblyOnly" : "AssemblyOnly"});

SPLM.JtCreator.PmiOption = Object.freeze({
    "None" : "None", "PartOnly" : "PartOnly", "AsmOnly" : "AsmOnly", "PartAndAsm" : "PartAndAsm", "ThisLevelOnly" : "ThisLevelOnly"});

SPLM.JtCreator.RefsetOption = Object.freeze({
    "Default" : "Default", "All" : "All", "AllNamed" : "AllNamed", "AsSpecified" : "AsSpecified"});

SPLM.JtCreator.TessellationOption = Object.freeze({
    "Defined" : "Defined", "Lw" : "Lw", "Nx" : "Nx"});

SPLM.JtCreator.AdvancedMaterials = Object.freeze({
    "None" : "None", "Low" : "Low", "High" : "High"});

SPLM.JtCreator.SelectionScope = Object.freeze({
    "EntirePart" : "EntirePart", "SelectedObjects" : "SelectedObjects"});

export default SPLM;